import type { OTCDealData } from '@src/types/OTC';
import { MixpanelEvent, type MixpanelInstance, type Security } from '@talos/kyoko';

type DealPropertyName = 'deal' | 'loan';

interface CreateDealJsonObjectParams<T extends DealPropertyName> {
  deal: OTCDealData | undefined;
  propertyName: T;
  securitiesBySymbol: Map<string, Security>;
  handleClickJson: (jsonObject: Record<T, OTCDealData> & { security: Security | undefined }) => void;
  mixpanel?: MixpanelInstance;
}

/**
 * Creates a custom JSON object with deal/loan and security information for display in JSON modal.
 * Used by both useOTCDerivativesMenu and useLoanMenu.
 */
export function createDealJsonObject<T extends DealPropertyName>({
  deal,
  propertyName,
  securitiesBySymbol,
  handleClickJson,
  mixpanel,
}: CreateDealJsonObjectParams<T>): void {
  if (!deal) {
    return;
  }
  mixpanel?.track(MixpanelEvent.ShowJSON);
  const security = deal.Symbol ? securitiesBySymbol.get(deal.Symbol) : undefined;
  const customJsonObject = {
    [propertyName]: deal,
    security,
  } as Record<T, OTCDealData> & { security: Security | undefined };
  handleClickJson(customJsonObject);
}
